var map = {
	"./act": 1530,
	"./act.ts": 1530,
	"./gmat": 1531,
	"./gmat.ts": 1531,
	"./gre": 1532,
	"./gre.ts": 1532,
	"./ielts": 1533,
	"./ielts.ts": 1533,
	"./ielts_general_training": 1534,
	"./ielts_general_training.ts": 1534,
	"./lsat": 1535,
	"./lsat.ts": 1535,
	"./mcat": 1536,
	"./mcat.ts": 1536,
	"./sat": 1537,
	"./sat.ts": 1537,
	"./toefl": 1538,
	"./toefl.ts": 1538
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2542;
module.exports = webpackAsyncContext;